import {FieldInput} from '../field-input'
import React from 'react'
import {VStack} from '@chakra-ui/react'
import {getIn, useFormikContext} from 'formik'

export const OptionalField = ({name, disabled, label, children, handleUpdate, ...props}: any) => {
  const {values} = useFormikContext()
  const isVisible = getIn(values, `${name}.response`) === 'true'

  return (
    <VStack w="full">
      <FieldInput
        name={`${name}.response`}
        label={label}
        componentType="radio-group"
        disabled={disabled}
        options={[
          {label: 'Yes', value: 'true'},
          {label: 'No', value: 'false'}
        ]}
        direction="row"
        handleChange={handleUpdate}
      />
      {children(isVisible)}
    </VStack>
  )
}
